import { fetchMyProjects } from '@/actions';
import { removeUrlParams } from '@/utils/utils';

const general = store => next => async action => {
	const state = store.getState();

	if (action.type === 'LOGIN_TELEGRAM_COMMIT') {
		removeUrlParams(['id', 'first_name', 'last_name', 'username', 'photo_url', 'auth_date', 'hash']);

		if (action.payload.token) {
			store.dispatch(fetchMyProjects(action.payload.token));
		}
	}

	return next(action);
};

export default general;
